import { any, filter, flatten, map, pipe, pluck, propEq, uniq } from "ramda";
import type { IEntity } from "interfaces/app";

const pluckEntityStores = pipe<IBrandGroup[], IEntity[][], IEntity[]>(
  pluck("stores"),
  flatten as (entities: IEntity[][]) => IEntity[]
);

const isAdminAnywhere = ({ stores }: IBrandGroup) => {
  return any(({ apps }) => any(propEq("isAdmin", true), apps), stores);
};

const isolateBrandIds = (entities: IEntity[]): string[] => {
  return uniq(pluck<"brandId", string>("brandId", entities));
};

const isolateBrandNames = (entities: IEntity[]): string[] => {
  return uniq(pluck<"brandName", string>("brandName", entities));
};

interface IBrandGroup {
  brand: string;
  brandId: string;
  stores: IEntity[];
}

const isolateBrandStores =
  (entities: IEntity[]) =>
  (brandId: string): IBrandGroup => {
    const brandStores: IEntity[] = filter(propEq("brandId", brandId), entities);

    return {
      brand: brandStores[0].brandName,
      brandId,
      stores: brandStores,
    };
  };

const sortEntitiesByBrand = (entities: IEntity[]): IBrandGroup[] => {
  const brandIds: string[] = isolateBrandIds(entities);
  return map(isolateBrandStores(entities), brandIds);
};

export {
  IBrandGroup,
  isAdminAnywhere,
  isolateBrandNames,
  isolateBrandIds,
  pluckEntityStores,
  sortEntitiesByBrand,
};
